const LoginPage = () => {
  const handleLogin = () => {
    window.location.href = "/login";
  };

  return (
    <div className="container d-flex flex-column justify-content-center align-items-center" style={{ height: '100%', width: '100%' }}>
      <div className="card shadow-lg p-4" style={{ maxWidth: '400px', width: '100%' }}>
        <h2 className="text-center mb-3 font-weight-bold">Sign in required</h2>
        <p className="text-center mb-4">
          To access <b>ADAP</b>, please sign in with your Microsoft account.
        </p>
        <div className="d-flex justify-content-center">
          <button onClick={handleLogin} className="btn btn-microsoft btn-lg d-flex align-items-center">
            <span style={{ marginRight: '8px' }}>
              {/* Microsoft SVG logo */}
              <svg width="24" height="24" viewBox="0 0 24 24" style={{ background: 'white' }}>
                <rect x="1" y="1" width="10" height="10" fill="#F35325" />
                <rect x="13" y="1" width="10" height="10" fill="#81BC06" />
                <rect x="1" y="13" width="10" height="10" fill="#05A6F0" />
                <rect x="13" y="13" width="10" height="10" fill="#FFBA08" />
              </svg>
            </span>
            <span>Sign in with Microsoft</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
